import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router';
import { UniversalSummarizeResumeLoader } from '../helpers/ai/universalSummarizeResume/UniversalSummarizeResumeLoader';
import { UniversalSummarizeResumeViewer } from '../helpers/ai/universalSummarizeResume/UniversalSummarizeResumeViewer';
import { AI_UTILITIES } from '../constants/aiUtilities';
import { useTheme } from '../components/hooks/useTheme';
import './Shared.css';

export const UniversalSummarizeResume = () => {
    const { theme } = useTheme();

    const icon = theme === 'light' ? AI_UTILITIES.UNIVERSAL_SUMMARIZE.lightIcon : AI_UTILITIES.UNIVERSAL_SUMMARIZE.darkIcon;

    return (
        <div>
            <Helmet>
                <title>{AI_UTILITIES.UNIVERSAL_SUMMARIZE.name}</title>
            </Helmet>
            <div className="d-flex flex-row align-items-center mb-3">
                <img src={icon} alt="Логотип" className='title-icon mr-3' />
                <h4>{AI_UTILITIES.UNIVERSAL_SUMMARIZE.name}</h4>
            </div>
            <Switch>
                <Route exact path={AI_UTILITIES.UNIVERSAL_SUMMARIZE.path} component={UniversalSummarizeResumeLoader} />
                <Route path={`${AI_UTILITIES.UNIVERSAL_SUMMARIZE.path}/:inputIdentifier`} component={UniversalSummarizeResumeViewer} />
            </Switch>
        </div>
    );
};

UniversalSummarizeResume.displayName = 'UniversalSummarizeResume';